import type { ReactNode } from 'react'
import { Box, Paper, Stack } from '@mui/material'
import { tokens } from '#app/theme'
import LanguageSwitcher from '#components/LanguageSwitcher'

// Shared shell for the login + consent surfaces, mirroring the
// marketplace "Sikker innlogging" look: a deep purple-900 canvas, a
// centered white card with near-square corners, and the white Fixrate
// logo anchored at the bottom.
export default function AuthLayout({
    children,
    maxWidth = 540,
    minHeight = 420,
}: {
    children: ReactNode
    maxWidth?: number
    minHeight?: number
}) {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                bgcolor: tokens.PURPLE_900,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 2,
                py: { xs: 4, sm: 8 },
            }}
        >
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
                <Paper
                    elevation={0}
                    sx={{
                        width: '100%',
                        maxWidth,
                        minHeight,
                        p: { xs: 3, sm: 4 },
                        borderRadius: '4px',
                        boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.2)',
                    }}
                >
                    {children}
                </Paper>
            </Box>
            <Stack alignItems="center" spacing={1.5} sx={{ pt: 4 }}>
                <LanguageSwitcher />
                <Box
                    component="img"
                    src="/logo-full-white.svg"
                    alt="Fixrate"
                    sx={{ height: 28, width: 'auto', opacity: 0.95 }}
                />
            </Stack>
        </Box>
    )
}
